export function getIpTableData(data) {
  return data.map((d) => ([[d.resolverLocation], [d.ipv6]]));
}
